import React from 'react';
import PropTypes from 'prop-types';
import {gql} from "apollo-boost";
import {Query} from "react-apollo";
import ComponentPage from "../ComponentPage";
import API from '../../config/API';
import HomePage from "../Home/HomePage";
import {isLandingPage, isWhatsNewPage} from "../../helpers/filters";
import WhatsNew from "../WhatsNew/WhatsNew";
import SiteIntroPage from "../SiteIntro/SiteIntroPage";
import ArticleRevision from "../Article/ArticleRevision";
import PageNotFound from "../404/404";

interface Data {
    nodeRevisionById: {
        entityId: string;
        status: boolean;
        entityBundle: string;
        entityUrl: Array<{
            path: string;
        }>;
    }
}

class RevisionQuery extends Query<Data, {id: string}> {}
const GET_PAGE = gql`
query nodeRevisionById($id: String!) {
  nodeRevisionById(id: $id) {
    entityId
    status
    entityBundle
    entityUrl {
      path
    }
  }
}
`;

const GET_SITEINTRO_PAGE = gql`
    query nodeRevisionById($id: String!) {
        nodeRevisionById(id: $id) {
            entityLabel
            ... on NodeSiteIntroPage {

                entityId
                entityLabel
                entityBundle
                entityUrl {
                    path
                }
                body {
                    processed
                }
                entityMetatags {
                    key
                    value
                }
                fieldBackgroundImageMedia {
                        entity {
                            ... on MediaImage {
                                fieldMediaImage {
                                    url
                                }
                            }
                        }
                }
            }
        }
    }
`;

const Revision = (props) => {
    const {id, nodeId} = props;
    return (
        <RevisionQuery asyncMode query={GET_PAGE} variables={{ id }}>
            {({ loading, error, data }) => {
                if (loading) return (<div className="pageLoader"/>);
                if (error) return <div>{error}</div>;

                const page = data.nodeRevisionById;
                if (!page) return (<PageNotFound/>);

                if (page.entityBundle === 'article') return (<ArticleRevision revisionId={id} isRevision />);

                if (isLandingPage(page.entityBundle)) return (<ComponentPage id={page.entityId} revisionId={id} />);

                if (page.entityBundle && page.entityBundle === 'site_intro_page') return (
                    <Query asyncMode query={GET_SITEINTRO_PAGE} variables={{ id }}>
                        {(siteIntroQueryResponse) => {
                            const siteIntroLoading = siteIntroQueryResponse.loading;
                            const siteIntroError = siteIntroQueryResponse.error;
                            const siteIntroData = siteIntroQueryResponse.data;

                            if (siteIntroLoading) return (<div className="pageLoader"/>);
                            if (siteIntroError) return <div>{error}</div>;

                            const siteIntroPage = siteIntroData.nodeRevisionById;
                            if (!siteIntroPage) return null; // TODO: Remove and enable 404
                            if (!siteIntroPage) return (<PageNotFound/>);

                            return (<SiteIntroPage {...siteIntroPage} />);
                        }}
                    </Query>
                );

                if (isWhatsNewPage(page.entityBundle)) return (<WhatsNew revisionId={id} isRevision />);

                if (nodeId && nodeId === API.homePageId) return (<HomePage revisionId={id}/>);

                return (
                    <h1>{page.entityBundle}</h1>
                );
            }}
        </RevisionQuery>
    );
};

Revision.propTypes = {
    id: PropTypes.string.isRequired,
    nodeId: PropTypes.string
};

Revision.defaultProps = {
    nodeId: ''
};

export default Revision;



// WEBPACK FOOTER //
// ./frontend/pages/Revision/Revision.jsx